<div class="max-w-4xl mx-auto p-5 bg-white shadow-md rounded-lg">
  <div class="mb-8 border-b pb-4">
    <h1 class="text-3xl font-bold mb-2">Orden de Trabajo #{{ workOrder?.id }}</h1>
    <p class="text-gray-600">Fecha: {{ workOrder?.paymentDate | date }}</p>
    <p class="text-gray-600">Estado:
      <span [ngClass]="{
          'text-yellow-600': workOrder?.status === 'PENDIENTE',
          'text-green-600': workOrder?.status === 'PAGADA',
          'text-red-600': workOrder?.status === 'ANULADA'
        }">{{ workOrder?.status }}</span>
    </p>

    <div class="mt-4 flex gap-3">
      <button (click)="downloadPdf()" [disabled]="isDownloadingPdf"
        class="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-300 transition-colors">
        <svg *ngIf="!isDownloadingPdf" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
        </svg>
        <svg *ngIf="isDownloadingPdf" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
          xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        {{ isDownloadingPdf ? 'Generando PDF...' : 'Descargar PDF' }}
      </button>
    </div>
  </div>

  <div class="mb-6 border-b pb-4">
    <h2 class="text-xl font-semibold mb-2">Detalles del Tercero</h2>
    <div class="grid grid-cols-1">
      <p><strong>Documento:</strong> {{ workOrder?.thirdParty?.typeDocument }} {{ workOrder?.thirdParty?.documentId }}
      </p>
      <p><strong>Nombres:</strong> {{ workOrder?.thirdParty?.firstName }} {{ workOrder?.thirdParty?.lastName }}</p>
      <p><strong>Correo:</strong> {{ workOrder?.thirdParty?.email }}</p>
      <p><strong>Teléfono</strong> {{ workOrder?.thirdParty?.phone }}</p>
    </div>
  </div>


  <div class="mb-6">
    <h2 class="text-xl font-semibold mb-2">Ordenante Pagador</h2>
    <p><strong>Nombre:</strong> {{ workOrder?.payer?.firstName }} {{ workOrder?.payer?.lastName }}</p>
  </div>

  <div class="mb-8">
    <h2 class="text-xl font-semibold mb-2">Ítems</h2>
    <div *ngFor="let item of workOrder?.workOrderItems" class="p-4 mb-4 bg-gray-100 rounded-lg shadow-sm relative">
      <h3 class="text-lg font-semibold">Proyecto: {{ item?.projectBudget?.project?.projectId }} - {{
        item?.projectBudget?.project?.name }}</h3>
      <p><strong>Categoría/Subcategoría:</strong> {{ item?.projectBudget?.budgetSubcategory?.budgetCategory?.name }} /
        {{ item?.projectBudget?.budgetSubcategory?.name }}</p>
      <p><strong>Detalles:</strong> {{ item?.details }}</p>
      <!-- <p><strong>Monto Proyectado:</strong> {{ item?.projectedAmount | currency }}</p> -->
      <p><strong>Cantidad:</strong> {{ item?.qty }}</p>
      <p><strong>Monto Ejecutado:</strong> {{ item?.executedAmount | currency }}</p>
    </div>
  </div>

  <div class="border-t pt-4">
    <h2 class="text-xl font-semibold">Monto Bruto: {{ workOrder?.totalBaseAmount | currency }}</h2>
    <h2 class="text-xl font-semibold">IVA: {{ workOrder?.totalVatAmount | currency }}</h2>
    <h2 class="text-xl font-semibold">Monto Neto: {{ workOrder?.totalAmount | currency }}</h2>
  </div>

  <!-- 🆕 HISTORIAL DE ANULACIONES DE COMPROBANTES DE EGRESO -->
  <div *ngIf="workOrder?.hasCancellationHistory && workOrder?.cancellationHistory?.length > 0"
    class="mt-6 bg-amber-50 border border-amber-200 rounded-lg p-4">
    <div class="flex items-center gap-2 mb-4">
      <svg class="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <h2 class="text-xl font-semibold text-amber-800">Historial de Anulaciones de Comprobantes de Egreso</h2>
      <span class="bg-amber-200 text-amber-800 px-3 py-1 rounded-full text-sm font-bold">
        {{ workOrder.cancellationHistory.length }} anulación(es)
      </span>
    </div>

    <div class="bg-amber-100 rounded-lg p-3 mb-4">
      <p class="text-amber-800 font-medium">
        Total monto anulado: <span class="text-lg font-bold">{{ workOrder.totalCancelledAmount | currency }}</span>
      </p>
      <p class="text-sm text-amber-700 mt-1">
        Esta orden de trabajo ha tenido comprobantes de egreso anulados. Consulta el detalle a continuación.
      </p>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full border-collapse">
        <thead>
          <tr class="bg-amber-200 text-amber-900 text-sm">
            <th class="p-3 text-left font-semibold">Egreso #</th>
            <th class="p-3 text-left font-semibold">Fecha Anulación</th>
            <th class="p-3 text-left font-semibold">Monto Anulado</th>
            <th class="p-3 text-left font-semibold">Estado Anterior</th>
            <th class="p-3 text-left font-semibold">Nuevo Estado</th>
            <th class="p-3 text-left font-semibold">Anulado Por</th>
            <th class="p-3 text-left font-semibold">Motivo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of workOrder.cancellationHistory; let i = index"
            [ngClass]="{'bg-white': i % 2 === 0, 'bg-amber-50': i % 2 !== 0}" class="border-b border-amber-100">
            <td class="p-3 text-sm font-medium text-amber-700">
              <a [routerLink]="['/expense-receipts/view', history.expenseVoucherId]"
                class="hover:underline flex items-center gap-1">
                #{{ history.expenseVoucherId }}
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </td>
            <td class="p-3 text-sm">{{ history.cancellationDate | date:'medium' }}</td>
            <td class="p-3 text-sm font-bold text-amber-700">{{ history.cancelledAmount | currency }}</td>
            <td class="p-3 text-sm">
              <span class="px-2 py-1 rounded-full text-xs font-medium" [ngClass]="{
                'bg-yellow-100 text-yellow-800': history.previousStatus === 'PENDIENTE',
                'bg-green-100 text-green-800': history.previousStatus === 'PAGADA',
                'bg-red-100 text-red-800': history.previousStatus === 'ANULADA'
              }">{{ history.previousStatus }}</span>
            </td>
            <td class="p-3 text-sm">
              <span class="px-2 py-1 rounded-full text-xs font-medium" [ngClass]="{
                'bg-yellow-100 text-yellow-800': history.newStatus === 'PENDIENTE',
                'bg-green-100 text-green-800': history.newStatus === 'PAGADA',
                'bg-red-100 text-red-800': history.newStatus === 'ANULADA'
              }">{{ history.newStatus }}</span>
            </td>
            <td class="p-3 text-sm text-gray-600">{{ history.cancelledBy }}</td>
            <td class="p-3 text-sm text-gray-600 max-w-xs truncate" [title]="history.cancellationReason">
              {{ history.cancellationReason }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>